module.exports = __webpack_public_path__ + "static/birdseye-187a45c96dcc858688060c74449e9851.jpg";